module.exports = __webpack_public_path__ + "img/not-draw-img@2x.6278ac0c.png";